import { atom } from 'nanostores';
import { useStore } from '@nanostores/react';

const HANDOFF_KEY = 'cio-onboarding-agent-handoff';
const HANDOFF_MARKER = '1';
const FIRST_RUN_KEY = 'cio-onboarding-wizard-first-run';

// Mirrors the stored note so a browser that blocks storage still hands off
// within the tab that started the conversation.
const $isFirstRun = atom(false);

const $isLoaderShowing = atom(false);

const $didAutoStart = atom(false);

const $hasIntent = atom(false);

export function setHasAgentHandoffIntent(hasIntent: boolean): void {
  $hasIntent.set(hasIntent);
}

export function useHasAgentHandoffIntent(): boolean {
  return useStore($hasIntent);
}

export function markAgentAutoStarted(): void {
  $didAutoStart.set(true);
}

export function resetAgentAutoStarted(): void {
  $didAutoStart.set(false);
}

export function getDidAgentAutoStart(): boolean {
  return $didAutoStart.get();
}

export function setIsAgentHandoffLoaderShowing(isShowing: boolean): void {
  $isLoaderShowing.set(isShowing);
}

export function getIsAgentHandoffLoaderShowing(): boolean {
  return $isLoaderShowing.get();
}

export function useIsAgentHandoffLoaderShowing(): boolean {
  return useStore($isLoaderShowing);
}

export function storeAgentHandoff(): void {
  try {
    sessionStorage.setItem(HANDOFF_KEY, HANDOFF_MARKER);
  } catch {}
}

export function peekAgentHandoff(): boolean {
  try {
    return sessionStorage.getItem(HANDOFF_KEY) === HANDOFF_MARKER;
  } catch {
    return false;
  }
}

export function clearAgentHandoff(): void {
  try {
    sessionStorage.removeItem(HANDOFF_KEY);
  } catch {}
}

/**
 * Notes that the wizard opened with nothing answered. `localStorage` rather
 * than session storage: a refresh mid-conversation must keep it. Only a
 * conversation carrying this note hands off to the agent at the end, so a
 * user who finished an earlier, shorter script and is routed back for a new
 * question never gets a second hand-off.
 */
export function markWizardFirstRun(): void {
  $isFirstRun.set(true);
  try {
    localStorage.setItem(FIRST_RUN_KEY, HANDOFF_MARKER);
  } catch {}
}

export function peekWizardFirstRun(): boolean {
  if ($isFirstRun.get()) {
    return true;
  }
  try {
    return localStorage.getItem(FIRST_RUN_KEY) === HANDOFF_MARKER;
  } catch {
    return false;
  }
}

export function clearWizardFirstRun(): void {
  $isFirstRun.set(false);
  try {
    localStorage.removeItem(FIRST_RUN_KEY);
  } catch {}
}
